export const GET_acquisitions = ({ acquisitions }) => {
  if (typeof acquisitions != 'undefined') {
    let acquisitions_list = []
    for (let index = 0; index < acquisitions.length; index++) {
      acquisitions_list[index] = { ...acquisitions[index] }

      const [year, month, day] = acquisitions_list[index].acquisition_date.split('-')
      acquisitions_list[index].formated_acquisition_date = `${day}/${month}/${year}`

      acquisitions_list[index].acquisition_price = new Intl.NumberFormat('pt-br', {
        style: 'currency',
        currency: 'BRL',
      }).format(parseFloat(acquisitions_list[index].acquisition_price))
    }
    return acquisitions_list.filter((acquisition) => {
      return acquisition.owner_entity_id === 1
    })
  }
}

export const GET_acquisitionsWithoutTransfered = ({ acquisitions }) => {
  if (typeof acquisitions != 'undefined') {
    let acquisitions_list = []
    for (let index = 0; index < acquisitions.length; index++) {
      if (acquisitions[index].acquisition_status_id != 4) {
        acquisitions_list[index] = { ...acquisitions[index] }

        const [year, month, day] = acquisitions_list[index].acquisition_date.split('-')
        acquisitions_list[index].formated_acquisition_date = `${day}/${month}/${year}`

        acquisitions_list[index].acquisition_price = new Intl.NumberFormat('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }).format(parseFloat(acquisitions_list[index].acquisition_price))
      }
    }
    return acquisitions_list.filter((acquisition) => {
      return acquisition.owner_entity_id === 1
    })
  }
}

export const GET_specifyAcquisition = (state, getters) => (acquisition_id) => {
  let acquisitions_list = getters.GET_acquisitionsWithoutTransfered
  return acquisitions_list.filter((acquisition) => {
    return acquisition.id === acquisition_id
  })
}

export const GET_specifyAcquisitionType = ({ acquisition_types }) => (type_id) => {
  return acquisition_types.filter((acquisition_types) => {
    return acquisition_types.id === type_id
  })
}

export const GET_specifyAcquisitionSource = ({ acquisition_sources }) => (source_id) => {
  return acquisition_sources.filter((acquisition_sources) => {
    return acquisition_sources.id === source_id
  })
}

// Invoices

export const GET_specifiedInvoice = ({ invoices }) => (invoice_id) => {
  let specified_invoices = invoices.find((invoice) => {
    return invoice.id === invoice_id
  })
  return specified_invoices
}
